var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { Button } from '@food/ui/build/dist/src/Button';
import { cns, subClass } from '@food/css-manager';
import { footer } from '../utils/theme';
export var WaitingReview = function (_a) {
    var onClose = _a.onClose, t = _a.t, isModal = _a.isModal, supportEmail = _a.supportEmail;
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", null, t(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Waiting Review"], ["Waiting Review"])))),
        React.createElement("section", null,
            React.createElement("div", { dangerouslySetInnerHTML: {
                    __html: t(templateObject_2 || (templateObject_2 = __makeTemplateObject(["Waiting review explanation html"], ["Waiting review explanation html"]))),
                } }),
            React.createElement("p", null, t(templateObject_3 || (templateObject_3 = __makeTemplateObject(["If you think we're wrong please"], ["If you think we're wrong please"]))),
                ' ',
                React.createElement("a", { href: "mailto:" + supportEmail }, t(templateObject_4 || (templateObject_4 = __makeTemplateObject(["contact us"], ["contact us"])))),
                "."),
            React.createElement("div", { className: cns(footer, subClass(footer, 'centered')) },
                React.createElement(Button, { label: t(isModal ? 'Close' : 'Proceed'), onClick: onClose, type: 'success' })))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=WaitingReview.js.map